import actionTypes from './type';

const initialState = {
  user: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case actionTypes.USER_CHANGED:
      console.log('USER_CHANGED', action);
      return {
        ...state,
        user: action.user,
      };
    default:
      return state;
  }
}
